const baseUrl = import.meta.env.VITE_POCKETBASE_URL || 'https://pb.mybooq.ai'

// Matches the 503 body emitted by the backend maintenance middleware
// (booq-backend-pocketbasego/hooks/maintenance_mode.go).
export const isMaintenanceResponse = (status: number, data: unknown): boolean =>
  status === 503 && typeof data === 'object' && data !== null && (data as { maintenance?: boolean }).maintenance === true

export const checkMaintenanceStatus = async (): Promise<boolean> => {
  try {
    const res = await fetch(`${baseUrl}/api/maintenance-status`)
    if (!res.ok) return false
    const data = await res.json()
    return data?.maintenance === true
  } catch {
    // Network errors are not maintenance — don't trap users on the blocker page.
    return false
  }
}

export const redirectToMaintenance = (): void => {
  if (window.location.pathname !== '/maintenance') {
    window.location.href = '/maintenance'
  }
}
